module.exports = __webpack_public_path__ + "img/joinCurve.e2f2b73b.svg";